import { createSlice } from "@reduxjs/toolkit";

export interface DeckState {
  showSkipped: boolean;
}

const initialState: DeckState = {
  showSkipped: true,
};

export const skippedSlice = createSlice({
  name: "skipped",
  initialState,
  reducers: {
    toggleSkipped: (state) => {
      state.showSkipped = !state.showSkipped;
    },
  },
});

export const { toggleSkipped } = skippedSlice.actions;

export default skippedSlice.reducer;
